import { __decorate } from 'tslib';
import { EventEmitter, Injectable, Input, Component, ViewEncapsulation, ElementRef, Output, HostBinding, HostListener, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { merge, fromEvent } from 'rxjs';
import { takeWhile, map } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';

var GlobalSearchboxServiceProvider = /** @class */ (function () {
    function GlobalSearchboxServiceProvider() {
        var _this = this;
        // === Main Search Input Box and Button ===
        // Search Input focus
        this.searchInputFocus = new EventEmitter();
        // current text in searchInput
        this.searchInputChange = new EventEmitter();
        // Search submit via searchButton or searchInput(Enter key)
        this.onSearch = new EventEmitter();
        // storing the string in searchInput for possible usage in future
        this._searchString = '';
        this.searchInputChange.subscribe(function (newString) {
            _this._searchString = newString;
        });
    }
    GlobalSearchboxServiceProvider.prototype._searchSubmit = function () {
        this.onSearch.emit(this._searchString);
    };
    GlobalSearchboxServiceProvider = __decorate([
        Injectable()
    ], GlobalSearchboxServiceProvider);
    return GlobalSearchboxServiceProvider;
}());

var GlobalSearchInputComponent = /** @class */ (function () {
    function GlobalSearchInputComponent(searchboxSvc) {
        this.searchboxSvc = searchboxSvc;
        /**
         * Label for Inputbox
         */
        this.label = 'Search for';
        /**
         * Maximum length of search string
         */
        this.maxLength = 5000;
        /**
         * Placeholder for Inputbox
         */
        this.placeholder = 'Enter a source name, a citation, terms or shep: [citation] to Shepardize®.';
        /**
         * Allows manual setting of the search terms in the input box.
         */
        this.searchText = '';
        // Internet Explorer 6-11 check
        this._isIE = false || !!document['documentMode'];
    }
    GlobalSearchInputComponent.prototype.onChange = function ($event) {
        this.searchboxSvc.searchInputChange.emit($event);
    };
    GlobalSearchInputComponent.prototype.onEnter = function ($event) {
        $event.preventDefault();
        this.searchboxSvc._searchSubmit();
    };
    GlobalSearchInputComponent.prototype.onFocusChange = function (newFocus) {
        this.searchboxSvc.searchInputFocus.emit(newFocus);
    };
    GlobalSearchInputComponent.ctorParameters = function () { return [
        { type: GlobalSearchboxServiceProvider }
    ]; };
    __decorate([
        Input()
    ], GlobalSearchInputComponent.prototype, "label", void 0);
    __decorate([
        Input()
    ], GlobalSearchInputComponent.prototype, "maxLength", void 0);
    __decorate([
        Input()
    ], GlobalSearchInputComponent.prototype, "placeholder", void 0);
    __decorate([
        Input()
    ], GlobalSearchInputComponent.prototype, "searchText", void 0);
    GlobalSearchInputComponent = __decorate([
        Component({
            selector: 'lng-search-input',
            template: "<label [innerHTML]=label></label>\n<div class=\"expandingtextarea-wrapper\">\n    <div>\n        <lng-expanding-textarea  attr.aria-label=\"{{label}}\" \n            contenteditable=\"true\" attr.placeholder= \"{{placeholder}}\" \n            attr.maxlength=\"{{maxLength}}\" [(ngModel)]=\"searchText\" \n            (change)=\"onChange($event)\"\n            (keydown.enter)=\"onEnter($event)\"\n            (focus)=\"onFocusChange(true)\" (focusout)=\"onFocusChange(false)\">\n        </lng-expanding-textarea>\n        <div class=\"fade\"></div>\n    </div>\n    <ng-content select=\"lng-search-autocomplete\"></ng-content>\n</div>",
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-search-input{position:relative;width:100%;flex-grow:1;display:flex;flex-direction:column}lng-search-input label{margin-bottom:9px;cursor:default;box-sizing:border-box;overflow:hidden;font-size:14px;color:#616161}lng-search-input .expandingtextarea-wrapper{z-index:3;box-sizing:border-box;display:flex;position:absolute;width:100%;top:25.7px;flex-direction:column}lng-search-input .expandingtextarea-wrapper lng-expanding-textarea{padding:13px 20px;line-height:normal;box-sizing:border-box;border:1px solid #e0e0e0;overflow:hidden;white-space:nowrap;z-index:1;display:block;font-size:20px;min-height:54px;flex-grow:1}lng-search-input .expandingtextarea-wrapper lng-expanding-textarea::after{white-space:nowrap;max-width:100%;overflow:hidden;font-style:italic;color:#bdbdbd;font-size:18px}lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:active,lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:focus{white-space:normal;outline:0;box-shadow:none;box-sizing:border-box;position:relative}lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:active+.fade,lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:focus+.fade{display:none}lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:active:empty .fade,lng-search-input .expandingtextarea-wrapper lng-expanding-textarea:focus:empty .fade{display:block}lng-search-input .expandingtextarea-wrapper div.fade{position:absolute;top:3px;right:1px;width:30px;bottom:3px;max-height:49px;background:linear-gradient(to right,rgba(255,255,255,0) 0,#fff 50%);pointer-events:none;z-index:9}"]
        })
    ], GlobalSearchInputComponent);
    return GlobalSearchInputComponent;
}());

var GlobalSearchButtonComponent = /** @class */ (function () {
    function GlobalSearchButtonComponent(searchboxSvc) {
        this.searchboxSvc = searchboxSvc;
        /**
         * Alternate Button Aria Label
         */
        this.ariaLabel = 'Search';
    }
    GlobalSearchButtonComponent.prototype.onButtonClick = function () {
        this.searchboxSvc._searchSubmit();
    };
    GlobalSearchButtonComponent.ctorParameters = function () { return [
        { type: GlobalSearchboxServiceProvider }
    ]; };
    __decorate([
        Input()
    ], GlobalSearchButtonComponent.prototype, "ariaLabel", void 0);
    GlobalSearchButtonComponent = __decorate([
        Component({
            selector: 'lng-search-button',
            template: "<button attr.aria-label=\"{{ariaLabel}}\" (click)=\"onButtonClick()\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24.001\" height=\"24\" viewBox=\"0 0 24.001 24\">\n        <rect width=\"24\" height=\"24\" opacity=\"0\"/>\n        <g transform=\"translate(0)\">\n            <path d=\"M12.567,22.633A9.789,9.789,0,0,1,2.8,12.866,9.94,9.94,0,0,1,12.567,3a9.817,9.817,0,0,1,0,19.633Zm0-18.449a8.653,8.653,0,0,0-8.583,8.583,8.583,8.583,0,1,0,8.583-8.583Z\" transform=\"translate(-2.8 -3)\"/>\n        </g>\n        <rect width=\"1.184\" height=\"10.063\" transform=\"translate(16.047 16.552) rotate(-45)\"/>\n    </svg>\n</button>",
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-search-button{display:flex;flex-flow:column;justify-content:flex-end}lng-search-button button{display:block;cursor:pointer;width:54px;height:54px;background-color:#f3403e}lng-search-button path,lng-search-button rect{fill:#fff}"]
        })
    ], GlobalSearchButtonComponent);
    return GlobalSearchButtonComponent;
}());

var GlobalSearchboxComponent = /** @class */ (function () {
    function GlobalSearchboxComponent() {
    }
    GlobalSearchboxComponent = __decorate([
        Component({
            selector: 'lng-searchbox',
            template: '<ng-content></ng-content>',
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-searchbox>.row{width:100%;display:flex;justify-content:space-between}lng-searchbox>.row:nth-child(n+2){margin-top:40px}"]
        })
    ], GlobalSearchboxComponent);
    return GlobalSearchboxComponent;
}());

var GlobalSearchAutocompleteComponent = /** @class */ (function () {
    function GlobalSearchAutocompleteComponent(_elementRef) {
        var _this = this;
        this._elementRef = _elementRef;
        /**
         * If true, this component will automatically close when it loses focus.
         */
        this.closeWhenFocusLost = true;
        /**
         * Broadcasts whenever this component loses focus.
         */
        this.focusLost = new EventEmitter();
        // Setup an observable for all selection changes
        this._onAnyFocusOrClick = merge(fromEvent(document, 'focusin'), fromEvent(document, 'click')).pipe(
        // Terminate when we're no longer open
        takeWhile(function () { return _this.open; }));
    }
    /**
     * Toggles the content open or closed.
     *
     * @param {boolean} value The desired state (open or closed)
     */
    GlobalSearchAutocompleteComponent.prototype.toggle = function (value) {
        var _this = this;
        this.open = value;
        if (!this.open) {
            return;
        }
        // Start listening for selections outside this component.
        this._onAnyFocusOrClick.subscribe(function (event) {
            // If something else has been selected
            if (!_this._elementRef.nativeElement.contains(event.target)) {
                _this.open = _this.closeWhenFocusLost ? false : _this.open;
                _this.focusLost.emit();
            }
        });
    };
    GlobalSearchAutocompleteComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Input()
    ], GlobalSearchAutocompleteComponent.prototype, "closeWhenFocusLost", void 0);
    __decorate([
        Output()
    ], GlobalSearchAutocompleteComponent.prototype, "focusLost", void 0);
    __decorate([
        HostBinding('class.open')
    ], GlobalSearchAutocompleteComponent.prototype, "open", void 0);
    GlobalSearchAutocompleteComponent = __decorate([
        Component({
            selector: 'lng-search-autocomplete',
            template: "<ng-container *ngIf=\"open\">\n  <ng-content select=\"lng-search-autocomplete-section\"></ng-content>\n</ng-container>\n\n ",
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-search-autocomplete{display:none;position:relative;width:100%;border-width:0 1px 1px;border-style:solid;border-color:#bcbec0;background:#fff;z-index:5;font-size:15px;box-sizing:border-box}lng-search-autocomplete.open{display:block}"]
        })
    ], GlobalSearchAutocompleteComponent);
    return GlobalSearchAutocompleteComponent;
}());

var GlobalSearchAutocompleteSectionComponent = /** @class */ (function () {
    function GlobalSearchAutocompleteSectionComponent() {
        /**
         * Provide option to remove section
         */
        this.removable = true;
        /**
         * Aria Label for the remove button
         */
        this.removeButtonAriaLabel = 'Remove Section';
        /**
         * Triggered when clicked on remove button
         */
        this.removed = new EventEmitter();
    }
    GlobalSearchAutocompleteSectionComponent.prototype.onRemoveSectionClick = function () {
        this.removed.emit(this.heading);
    };
    __decorate([
        Input()
    ], GlobalSearchAutocompleteSectionComponent.prototype, "removable", void 0);
    __decorate([
        Input()
    ], GlobalSearchAutocompleteSectionComponent.prototype, "heading", void 0);
    __decorate([
        Input()
    ], GlobalSearchAutocompleteSectionComponent.prototype, "removeButtonAriaLabel", void 0);
    __decorate([
        Output()
    ], GlobalSearchAutocompleteSectionComponent.prototype, "removed", void 0);
    GlobalSearchAutocompleteSectionComponent = __decorate([
        Component({
            selector: 'lng-search-autocomplete-section',
            template: "<div class=\"section-header\">\n    <button *ngIf=\"removable\" class=\"close\" (click)=\"onRemoveSectionClick()\" attr.aria-label=\"{{removeButtonAriaLabel}} {{heading}}\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 24 24\">\n            <rect width=\"12\" height=\"12\" transform=\"translate(0 0)\" opacity=\"0\"/>\n            <g transform=\"translate(0 0)\">\n                <line x1=\"22.667\" y1=\"22.667\" transform=\"translate(0.667 0.667)\" fill=\"none\"/>\n                <line y1=\"22.667\" x2=\"22.667\" transform=\"translate(0.667 0.667)\" fill=\"none\"/>\n                <path d=\"M26.4,3.733,25.067,2.4,14.4,13.067,3.733,2.4,2.4,3.733,13.067,14.4,2.4,25.067,3.733,26.4,14.4,15.733,25.067,26.4,26.4,25.067,15.733,14.4Z\" transform=\"translate(-2.4 -2.4)\"/>\n            </g>\n        </svg>\n    </button>\n    <div class=\"section-title-wrapper\">\n        <span class=\"section-name\" [innerHTML]=\"heading\"></span>\n    </div>\n</div>\n<div class=\"section-content\">\n    <ng-content></ng-content>\n</div>\n",
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-search-autocomplete-section{display:flex;flex-direction:row}lng-search-autocomplete-section .section-header{background-color:#f4f4f5;min-width:160px;box-sizing:border-box;padding:15px 15px 0 0;text-align:right;color:#6d6e71;font-weight:700;display:flex;justify-content:space-between}lng-search-autocomplete-section .section-header button.close{width:14px;height:14px;margin-left:10px;opacity:0}lng-search-autocomplete-section .section-header button.close path{fill:#6d6e71}lng-search-autocomplete-section .section-header button.close:focus{opacity:1}lng-search-autocomplete-section .section-header button.close:hover{cursor:pointer}lng-search-autocomplete-section .section-header button.close:hover path{fill:#ed1c24}lng-search-autocomplete-section .section-header:hover button.close{opacity:1}lng-search-autocomplete-section .section-content:not(:empty){width:100%;display:flex;flex-direction:column;padding-top:15px}lng-search-autocomplete-section .section-content:not(:empty) .section-item{padding:5px 0 5px 15px;align-items:center;min-height:21px;background-color:#fff}lng-search-autocomplete-section .section-content:not(:empty) .section-item:hover{background-color:#f4f4f5;cursor:pointer}"]
        })
    ], GlobalSearchAutocompleteSectionComponent);
    return GlobalSearchAutocompleteSectionComponent;
}());

var GlobalSearchOptionsMenuComponent = /** @class */ (function () {
    function GlobalSearchOptionsMenuComponent(_elementRef) {
        var _this = this;
        this._elementRef = _elementRef;
        /**
         * Alternate Label
         */
        this.label = 'starting in';
        /**
         * Alignment for drop down menu, center/left/right
         */
        this.align = 'center';
        /**
         * Manual horizontal offset for drop down menu, in pixels. +ve for right, -ve for left
         */
        this.offsetX = 0;
        /**
         * If true, this component will automatically close when it loses focus.
         */
        this.closeWhenFocusLost = true;
        /**
         * Broadcasts whenever this component opens or closes.
         */
        this.toggled = new EventEmitter();
        this.open = false;
        // Setup an observable for all selection changes
        this._onAnyFocusOrClick = merge(fromEvent(document, 'focusin'), fromEvent(document, 'click')).pipe(
        // Terminate when we're no longer open
        takeWhile(function () { return _this.open; }));
    }
    /**
     * Toggles the content open or closed.
     *
     * @param {boolean} value The desired state (open or closed)
     */
    GlobalSearchOptionsMenuComponent.prototype.toggle = function (value) {
        var _this = this;
        this.open = value;
        this.toggled.emit(this.open);
        if (!this.open) {
            return;
        }
        // Start listening for selections outside this component.
        this._onAnyFocusOrClick.subscribe(function (event) {
            // If something else has been selected
            if (!_this._elementRef.nativeElement.contains(event.target)) {
                _this.open = _this.closeWhenFocusLost ? false : _this.open;
                _this.toggled.emit(_this.open);
            }
        });
    };
    GlobalSearchOptionsMenuComponent.prototype.dropDownMenuClass = function () {
        return "drop-down-menu-wrapper " + this.align;
    };
    GlobalSearchOptionsMenuComponent.prototype.dropDownMenuRightOffset = function () {
        return this.align === 'right' && this.offsetX !== 0 ? -1 * this.offsetX + "px" : '';
    };
    GlobalSearchOptionsMenuComponent.prototype.dropDownMenuLeftOffset = function () {
        return this.offsetX !== 0 && this.align === 'left' ? this.offsetX + "px" : '';
    };
    GlobalSearchOptionsMenuComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Input()
    ], GlobalSearchOptionsMenuComponent.prototype, "label", void 0);
    __decorate([
        Input()
    ], GlobalSearchOptionsMenuComponent.prototype, "align", void 0);
    __decorate([
        Input()
    ], GlobalSearchOptionsMenuComponent.prototype, "offsetX", void 0);
    __decorate([
        Input()
    ], GlobalSearchOptionsMenuComponent.prototype, "closeWhenFocusLost", void 0);
    __decorate([
        Output()
    ], GlobalSearchOptionsMenuComponent.prototype, "toggled", void 0);
    GlobalSearchOptionsMenuComponent = __decorate([
        Component({
            selector: 'lng-search-options-menu',
            template: "<div class=\"search-options\" >\n    <label class=\"options-label\" [innerHTML]=label></label>\n    <button [attr.aria-expanded]=\"open\" class=\"options-button\" [class.open]=\"open\" (click)=\"toggle(!open)\">\n        <ng-content select=\"[heading]\"></ng-content>\n        <svg *ngIf=\"!open\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\">\n            <rect width=\"14\" height=\"14\" fill=\"#00172e\" opacity=\"0\"/>\n            <g transform=\"translate(0 6)\">\n                <path d=\"M15.5,21.2l-12-10.33L4.857,9.3,15.5,18.483,26.143,9.3,27.5,10.865Z\" transform=\"translate(-3.5 -9.301)\" fill=\"#00172e\"/>\n            </g>\n        </svg>\n        <svg *ngIf=\"open\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\">\n            <rect width=\"14\" height=\"14\" fill=\"#00172e\" opacity=\"0\"/>\n            <g transform=\"translate(0 6)\">\n                <path d=\"M15.5,9.3l12,10.33L26.143,21.2,15.5,12.013,4.857,21.2,3.5,19.63Z\" transform=\"translate(-3.5 -9.301)\" fill=\"#00172e\"/>\n            </g>\n        </svg>\n    </button>\n</div>\n<div *ngIf=\"open\" \n    [class]=\"dropDownMenuClass()\" \n    [class.open]=\"open\" \n    [style.left]=\"align === 'center' ? 'calc(50% - ' + (-1 * offsetX) + 'px' + ')' : dropDownMenuLeftOffset()\" \n    [style.right]=\"dropDownMenuRightOffset()\">\n    <ng-content select=\"[content]\"></ng-content>\n</div>\n",
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-search-options-menu{text-align:left;position:relative}lng-search-options-menu div.search-options{display:flex;flex-direction:column}lng-search-options-menu div.search-options label.options-label{font-size:14px;margin-bottom:9px;color:#373739}lng-search-options-menu div.search-options button.options-button{width:100%;position:relative;border-radius:1px;border:1px solid #bcbec0;padding:0 14px;height:54px;cursor:pointer;display:flex;justify-content:space-between;align-items:center;background-color:#fff}lng-search-options-menu div.search-options button.options-button path{fill:#6d6e71}lng-search-options-menu div.search-options button.options-button.open{border-color:#07c #07c #fff;z-index:14}lng-search-options-menu div.search-options button.options-button.open::after{position:absolute;z-index:14;display:block;content:\"\";border-top:1px solid #bcbec0;width:calc(100% - 2 * 14px);bottom:-1px}lng-search-options-menu .drop-down-menu-wrapper{position:absolute;border:1px solid #bcbec0;margin-top:-1px;z-index:13;min-width:100%;box-sizing:border-box;background-color:#fff}lng-search-options-menu .drop-down-menu-wrapper.open{border:1px solid #07c}lng-search-options-menu .drop-down-menu-wrapper.center{left:50%;right:auto;transform:translate(-50%,0)}lng-search-options-menu .drop-down-menu-wrapper.right{right:0}.row:first-child lng-search-options-menu{margin-left:-1px;border-radius:0}.row:first-child lng-search-options-menu :last-child .options-button{border-right:none}"]
        })
    ], GlobalSearchOptionsMenuComponent);
    return GlobalSearchOptionsMenuComponent;
}());

var GlobalExpandingTextAreaComponent = /** @class */ (function () {
    /**
     * Make the template content editable
     *
     * @param {ElementRef=} el - Self Element
     */
    function GlobalExpandingTextAreaComponent(el) {
        this.el = el;
        /**
         * in order for the parent component to listen to the change event, we need to pass it as an output
         */
        this.change = new EventEmitter();
        /**
         * the value that the template will use for search string
         */
        this.searchString = '';
        /**
         * Stores a valid value to reset it if the term goes over max length
         */
        this.validValue = '';
        // Internet Explorer 6-11 check
        this._isIE = false || !!document['documentMode'];
        this.el.nativeElement.setAttribute('contenteditable', true);
        this.maxlength = this.el.nativeElement.getAttribute('maxlength');
        this.mapDeletionKeyUpEventsForIE();
    }
    GlobalExpandingTextAreaComponent_1 = GlobalExpandingTextAreaComponent;
    /**
     * When the input changes, we need to notify the parent that the model changed, and fire off a change event
     *
     * @param {Event=} evt - Input Event in textarea
     */
    GlobalExpandingTextAreaComponent.prototype.onChange = function (evt) {
        var newVal;
        var el = evt.target;
        this.maxlength = this.el.nativeElement.getAttribute('maxlength');
        if (this.maxlength && this.maxlength < el.innerText.length) {
            // When the search string reaches maxlength, we ignore the input and set the text back to the last valid value
            newVal = this.validValue || '';
            el.innerText = newVal;
            this.moveCursorToEnd(this.el.nativeElement);
        }
        else {
            newVal = el.innerText || '';
            this.validValue = newVal;
        }
        this.callbackToParent(newVal);
        this.change.emit(newVal);
    };
    GlobalExpandingTextAreaComponent.prototype.onChangeIE = function (evt) {
        this.onChange.call(this, evt);
    };
    /**
     * We need to listen for the paste event because the contenteditable attribute allows for html input, including formatting and such
     *
     * @param {ClipboardEvent=} evt - When you paste in textarea
     */
    GlobalExpandingTextAreaComponent.prototype.onPaste = function (evt) {
        var _this = this;
        // stop the event
        evt.preventDefault();
        var text = '';
        if (evt.clipboardData) {
            text = evt.clipboardData.getData('text/plain');
        }
        else if (window['clipboardData']) {
            text = window['clipboardData'].getData('Text');
        }
        if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
        }
        else {
            var range = document.getSelection().getRangeAt(0);
            range.deleteContents();
            var textNode = document.createTextNode(text);
            range.insertNode(textNode);
            range.selectNodeContents(textNode);
            range.collapse(false);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
        // wait for browser to insert text in correct position
        setTimeout(function () {
            _this.maxlength = _this.el.nativeElement.getAttribute('maxlength');
            var innerTextValueAfterPaste = _this.el.nativeElement.innerText;
            _this.validValue = innerTextValueAfterPaste.slice(0, _this.maxlength) || '';
            if (String.prototype.normalize !== undefined) {
                _this.validValue = _this.validValue.normalize('NFKC');
            }
            // set the validValue back to input if validValue length is different than innerTextLength
            // due to applying maxlength constraint
            if (_this.validValue.length !== _this.el.nativeElement.innerText.length) {
                _this.el.nativeElement.innerText = _this.validValue;
                _this.moveCursorToEnd(_this.el.nativeElement);
            }
            // update the parent model
            _this.callbackToParent(_this.validValue);
            // emit a change
            _this.change.emit(_this.validValue);
        });
    };
    GlobalExpandingTextAreaComponent.prototype.onFocus = function () {
        // move the cursor
        this.moveCursorToEnd(this.el.nativeElement);
    };
    /**
     * this is a placeholder, as the actual value will be set to the callback function that Angular provides in registerOnChange
     *
     * @param {string=} value - Function yet to be implemented
     */
    GlobalExpandingTextAreaComponent.prototype.callbackToParent = function (value) {
        // this function is yet to be implemented
    };
    /**
     * Angular calls writeValue when the field that is passed through ngModel changes
     *
     * @param {string=} value - string to show in textarea
     */
    GlobalExpandingTextAreaComponent.prototype.writeValue = function (value) {
        this.searchString = value || '';
        this.el.nativeElement.innerText = this.searchString;
    };
    /**
     * Angular needs to pass this component a function that you have to call manually whenever the value changes
     *
     * @param {any} fn
     *
     * Commenting out the function as it is never called
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalExpandingTextAreaComponent.prototype.registerOnChange = function (fn) {
        this.callbackToParent = fn;
    };
    /**
     * registerOnTouched passes a function, that will be used as a callback function when the input has been interacted with
     *
     * @param {any} fn
     *
     * Commenting out the function as it is never called
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalExpandingTextAreaComponent.prototype.registerOnTouched = function (fn) {
        // this function is yet to implemented
    };
    /**
     *
     * @param isDisabled
     *
     * Commenting out the function as it is never called
     */
    // public setDisabledState?(isDisabled: boolean): void {}
    /**
     * move the cursor back to the end of the element
     *
     * @param {ElementRef=} el - textarea
     */
    GlobalExpandingTextAreaComponent.prototype.moveCursorToEnd = function (el) {
        if (!el['innerText']) {
            return;
        }
        // need this timeout for it to work correctly
        setTimeout(function () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var doc = document;
            var range;
            if (doc.createRange) {
                // firefox, Chrome, Opera, Safari, IE 9+
                range = doc.createRange(); // create a range (a range is a like the selection but invisible)
                range.selectNodeContents(el); // select the entire contents of the element with the range
                range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                var selection = window.getSelection(); // get the selection object (allows you to change selection)
                selection.removeAllRanges(); // remove any selections already made
                selection.addRange(range); // make the range you have just created the visible selection
            }
            else if (doc['selection']) {
                // iE 8 and lower
                range = doc.body.createTextRange(); // create a range (a range is a like the selection but invisible)
                range.moveToElementText(el); // select the entire contents of the element with the range
                range.collapse(false); // collapse the range to the end point. false means collapse to end rather than the start
                range.select(); // select the range (make it the visible selection
            }
        }, 20);
    };
    GlobalExpandingTextAreaComponent.prototype.getSelection = function () {
        return window.getSelection().toString();
    };
    GlobalExpandingTextAreaComponent.prototype.mapDeletionKeyUpEventsForIE = function () {
        if (!this._isIE) {
            return;
        }
        var BACKSPACE = 8;
        var DELETE = 46;
        this.el.nativeElement.addEventListener('keyup', function (event) {
            var isDeleting = BACKSPACE === event.keyCode || DELETE === event.keyCode;
            if (isDeleting) {
                var customInputEvent = document.createEvent('Event');
                customInputEvent.initEvent('input', true, false);
                customInputEvent['data'] = null;
                event.target.dispatchEvent(customInputEvent);
            }
        }, true);
    };
    var GlobalExpandingTextAreaComponent_1;
    GlobalExpandingTextAreaComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Output()
    ], GlobalExpandingTextAreaComponent.prototype, "change", void 0);
    __decorate([
        HostListener('input', ['$event'])
    ], GlobalExpandingTextAreaComponent.prototype, "onChange", null);
    __decorate([
        HostListener('textinput', ['$event'])
    ], GlobalExpandingTextAreaComponent.prototype, "onChangeIE", null);
    __decorate([
        HostListener('paste', ['$event'])
    ], GlobalExpandingTextAreaComponent.prototype, "onPaste", null);
    __decorate([
        HostListener('focus')
    ], GlobalExpandingTextAreaComponent.prototype, "onFocus", null);
    GlobalExpandingTextAreaComponent = GlobalExpandingTextAreaComponent_1 = __decorate([
        Component({
            selector: 'lng-expanding-textarea',
            template: '',
            providers: [{
                    provide: NG_VALUE_ACCESSOR,
                    useExisting: GlobalExpandingTextAreaComponent_1,
                    multi: true,
                }],
            encapsulation: ViewEncapsulation.None,
            styles: ["lng-expanding-textarea{width:100%;background-color:#fff;position:relative;display:inline-block}lng-expanding-textarea:empty::before{display:none}lng-expanding-textarea:empty::after{content:attr(placeholder);display:block;cursor:text}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){lng-expanding-textarea:empty::after{top:5px;position:absolute}lng-expanding-textarea:empty::after:focus:-ms-input-placeholder{display:none}}"]
        })
    ], GlobalExpandingTextAreaComponent);
    return GlobalExpandingTextAreaComponent;
}());

var GlobalSearchboxModule = /** @class */ (function () {
    function GlobalSearchboxModule() {
    }
    GlobalSearchboxModule = __decorate([
        NgModule({
            exports: [
                GlobalExpandingTextAreaComponent,
                GlobalSearchInputComponent,
                GlobalSearchButtonComponent,
                GlobalSearchboxComponent,
                GlobalSearchAutocompleteComponent,
                GlobalSearchAutocompleteSectionComponent,
                GlobalSearchOptionsMenuComponent,
            ],
            declarations: [
                GlobalExpandingTextAreaComponent,
                GlobalSearchInputComponent,
                GlobalSearchButtonComponent,
                GlobalSearchboxComponent,
                GlobalSearchAutocompleteComponent,
                GlobalSearchAutocompleteSectionComponent,
                GlobalSearchOptionsMenuComponent,
            ],
            imports: [
                CommonModule,
                FormsModule,
            ],
            providers: [GlobalSearchboxServiceProvider],
        })
    ], GlobalSearchboxModule);
    return GlobalSearchboxModule;
}());

/**
 * Public API Surface of ln-templates-angular searchbox
 */

/*
 * Auth layout breakpoints
 */
var Breakpoints = {
    SMALL: '360px',
    MEDIUM: '600px',
    LARGE: '1024px',
    XLARGE: '1440px',
};

/**
 * The prefix to apply to selectors, classnames etc.
 */
var prefix = 'ln';

var AuthLayout = /** @class */ (function () {
    function AuthLayout(_observer) {
        this._observer = _observer;
    }
    AuthLayout.prototype.ngOnInit = function () {
        this.isLargeScreen$ = this._observer.observe("(min-width: " + Breakpoints.LARGE + ")")
            .pipe(map(function (state) { return state.matches; }));
    };
    AuthLayout.ctorParameters = function () { return [
        { type: BreakpointObserver }
    ]; };
    AuthLayout = __decorate([
        Component({
            selector: prefix + "-auth-layout",
            template: "<div class=\"container\">\n  <section class=\"primary\">\n    <div class=\"branding\">\n      <ng-content select=\"[branding]\"></ng-content>\n    </div>\n    <section class=\"main-content\">\n      <header class=\"title-block\">\n        <ng-content select=\"[title-block]\"></ng-content>\n      </header>\n      <div class=\"contents\">\n        <ng-content select=\"[contents]\"></ng-content>\n      </div>\n    </section>\n  </section>\n  <section class=\"secondary\">\n    <div *ngIf=\"isLargeScreen$ | async\" class=\"background\">\n      <ng-content select=\"[background-image]\"></ng-content>\n    </div>\n    <section class=\"cta-callout\">\n      <ng-content select=\"[cta-callout]\"></ng-content>\n    </section>\n    <section *ngIf=\"isLargeScreen$ | async\" class=\"marketing\">\n      <ng-content select=\"[marketing]\"></ng-content>\n    </section>\n    <section class=\"footer\">\n      <ng-content select=\"[footer]\"></ng-content>\n    </section>\n  </section>\n</div>\n",
            encapsulation: ViewEncapsulation.None,
            styles: [".ln-input{min-width:320px;height:48px;padding:12px 16px;border:2px solid var(--ln-input-border,#acbac9);border-radius:4px;box-sizing:border-box;font-size:16px;color:var(--ln-text-01,#455a64);-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-bottom:16px}.ln-input:hover{border-color:var(--ln-input-border--focus,#4fc3f7)}.ln-input:focus{border-color:var(--ln-input-border--focus,#4fc3f7);box-shadow:0 0 0 4px rgba(var(--ln-input-border--focus-rgb,79,195,247),16%);outline:0}.ln-input.error{border-color:var(--ln-input-border--error,#d60019);box-shadow:0 0 0 2px rgba(var(--ln-input-border--error-rgb,214,0,25),16%)}.ln-input[disabled]{border-color:var(--ln-input-border--disabled,#eceff1);background-color:rgba(var(--ln-input-border--disabled-rgb,236,239,241),50%)}.ln-input ::-moz-placeholder{opacity:1}.ln-input :-ms-input-placeholder{opacity:1}.ln-input ::placeholder{opacity:1}button[ln-dismiss-button]{align-items:center;background-color:var(--ln-background-interactive,#fafafa);border-radius:50%;box-sizing:border-box;cursor:pointer;display:inline-flex;height:32px;justify-content:center;width:32px}button[ln-dismiss-button]:hover{background-color:var(--ln-background-interactive--hover,#f5f5f5)}button[ln-dismiss-button]:active{background-color:var(--ln-background-interactive--active,#eee)}button[ln-dismiss-button]:focus{background-color:var(--ln-background-interactive--focus,transparent);box-shadow:0 0 0 2px var(--ln-input-border--focus,#4fc3f7)}button[ln-dismiss-button]:disabled{cursor:default;opacity:.24}button[ln-dismiss-button] svg{fill:none;stroke:var(--ln-icon-01,#455a64);stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}.ln-link{color:var(--ln-link,#0d47a1);cursor:pointer;padding:4px;text-decoration:underline;text-underline-offset:4px}.ln-link:hover{color:var(--ln-link--hover,#1565c0);text-decoration:none}.ln-link:active{color:var(--ln-link--active,#1976d2);text-decoration:none}.ln-link:focus{color:var(--ln-link--focus,#0d47a1);text-decoration:none;border-radius:4px;box-shadow:0 0 0 2px var(--ln-input-border--focus,#4fc3f7)}.ln-link:disabled{cursor:default;opacity:.24;text-decoration:none}.container{display:flex;flex-direction:column;height:100vh;background:#fff;font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:400;font-size:16px;line-height:24px}.container h1{font-style:normal;font-weight:700;font-size:32px;line-height:48px;font-family:UBIQ,'Helvetica Neue',Arial,sans-serif}.container h2{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:600;font-size:28px;line-height:32px}.container h3{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;line-height:32px}.container .primary>*,.container .secondary>*{padding:32px}.container .primary{display:-ms-grid;display:grid;-ms-grid-rows:max-content auto;grid-template-rows:max-content auto}.container .primary .main-content{padding:0;display:flex;flex-direction:column;justify-content:center}.container .primary .main-content .contents,.container .primary .main-content .title-block{padding:32px}.container .primary .main-content .title-block{padding-top:0;display:flex}.container .primary .main-content .title-block .title-block-content{margin-left:24px}.container .primary .branding,.container .primary .title-block{background-color:#00172e;color:#fff}.container .primary .branding span,.container .primary .title-block span{color:#b0bec5;font:16px/32px Lato,'Helvetica Neue',Arial,sans-serif;margin-top:8px;display:inline-block}.container .primary .branding .insight-bar,.container .primary .title-block .insight-bar{background:linear-gradient(270deg,#f6271c 0,#ec407a 100%);height:auto;width:8px;border-radius:4px}.container .primary .branding h3 sup,.container .primary .title-block h3 sup{vertical-align:super;font-size:25%;position:relative;top:-.5em}.container .primary .branding{display:flex;align-items:center}.container .primary .branding svg+h3{padding-left:8px;font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:700;font-size:20px;line-height:28px}.container .secondary{display:-ms-grid;display:grid;-ms-grid-rows:max-content auto max-content;grid-template-rows:max-content auto max-content}.container .secondary .cta-callout{display:flex;flex-direction:column;background-color:#fafafa;place-content:center;align-items:center}.container .secondary .cta-callout>:nth-last-child(n+2){margin-bottom:32px}.container .secondary .cta-callout:empty{display:none}.container .secondary .marketing{flex-direction:row}.container .secondary .marketing .insight-bar{background:linear-gradient(270deg,#f6271c 0,#ec407a 100%);width:4px;border-radius:2px;margin-right:32px;flex-shrink:0}.container .secondary .marketing .content>:nth-last-child(n+2){margin-bottom:16px}.container .secondary .marketing .content .button-row{margin-top:32px}@media (min-width:600px){.container .primary .main-content .contents,.container .primary .main-content .title-block,.container .primary>*,.container .secondary>*{padding:40px}.container .primary .main-content .title-block{padding-top:0}}@media (min-width:1024px){.container{display:-ms-grid;display:grid;-ms-grid-columns:38.2% 61.8%;grid-template-columns:38.2% 61.8%}.container .primary .main-content .contents,.container .primary .main-content .title-block,.container .primary>*,.container .secondary>*{padding:32px}.container .primary .main-content .contents{margin-top:-32px}.container .primary .branding,.container .primary .title-block{background-color:#fff;color:#00172e}.container .primary .branding span,.container .primary .title-block span{color:#546e7a;font-size:18px}.container .secondary{color:#fff;background-color:#00172e;position:relative}.container .secondary h2{color:#fff}.container .secondary .background{position:absolute;z-index:1;width:100%;top:0;bottom:0;padding:0;mix-blend-mode:luminosity;opacity:.4;overflow:hidden}.container .secondary .background::before{content:\"\";background:linear-gradient(180deg,rgba(0,0,0,0) 0,rgba(0,0,0,.5) 100%);position:absolute;bottom:0;left:0;width:100%;height:75%}.container .secondary .background img{height:100%;width:100%;-o-object-fit:cover;object-fit:cover}.container .secondary .footer{position:absolute;bottom:0;left:0;right:0}.container .secondary>*{position:relative;z-index:2}.container .secondary .marketing{display:flex;align-self:center;padding:64px}.container .secondary .cta-callout{justify-content:flex-end;flex-direction:row;background-color:transparent}.container .secondary .cta-callout>:nth-last-child(n+2){margin-bottom:0;margin-right:16px}.container .secondary .ln-button.ln-button-secondary{background-color:inherit;color:inherit;border-color:inherit}.container .secondary .ln-button.ln-button-secondary:hover{border-color:inherit;background-color:inherit;color:inherit;box-shadow:0 0 0 2px #687c96}.container .secondary .ln-button.ln-button-secondary:active,.container .secondary .ln-button.ln-button-secondary:focus{background-color:inherit;color:inherit;border-color:inherit}.container .secondary .ln-button.ln-button-secondary:active{box-shadow:none}}@media (min-width:1920px){.container h1{font:600 42px/48px UBIQ,'Helvetica Neue',Arial,sans-serif}.container h2{font:600 42px/56px UBIQ,'Helvetica Neue',Arial,sans-serif}.container .marketing p{color:#fff;font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:400;font-size:18px;line-height:32px}.container .primary>*,.container .secondary>*{padding:64px}.container .primary .main-content .contents,.container .primary .main-content .title-block{padding:64px 128px}.container .primary .main-content .contents{margin-top:-64px}.container .primary .branding span,.container .primary .title-block span{color:#546e7a;font-size:24px}.container .primary .branding h3{line-height:56px}.container .secondary .marketing{padding:128px}}", ".auth-form{display:flex;flex-direction:column}.auth-form>:nth-last-child(n+2){margin-bottom:32px}.auth-form .ln-input-field label{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:700;font-size:16px;line-height:24px}.auth-form .ln-input-field input{cursor:pointer;margin-top:16px;min-width:160px;width:100%}.auth-form .ln-form-group{display:flex;flex-direction:column}.auth-form .ln-form-group>:nth-last-child(n+2){margin-bottom:32px}.auth-form .ln-form-group .flex-spacer{display:none;flex:1}.auth-form .ln-form-group .links{display:flex;justify-content:space-between}.auth-form .ln-form-group .links a{text-decoration:underline;font:16px/24px Lato,'Helvetica Neue',Arial,sans-serif;color:#0d47a1}.auth-form .ln-radio-button{align-items:center;background-color:#fff;border:2px solid #aebac8;border-radius:4px;color:#546e7a;cursor:pointer;display:flex;height:72px;margin-bottom:16px;position:relative}.auth-form .ln-radio-button:hover{border:2px solid #687c96}.auth-form .ln-radio-button:disabled{border:2px solid #eceff1}.auth-form .ln-radio-button label{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:700;font-size:14px;line-height:24px;text-transform:uppercase}.auth-form .ln-radio-button .ln-method-description{display:flex;flex-direction:column;flex:1}.auth-form .ln-radio-button .icon{margin:24px}.auth-form .ln-radio-button input[type=radio]{position:absolute;top:0;left:0;right:0;bottom:0;opacity:.01;z-index:100}.auth-form .ln-radio-button .checkmark{display:none;position:absolute;right:32px;top:24px}.auth-form .ln-radio-button:focus-within{box-shadow:2px 2px 2px 2px #4fc3f729}.auth-form .ln-radio-button.checked{background-color:#4fc3f714;border:2px solid #4fc3f7}.auth-form .ln-radio-button.checked .ln-method-description>.label{font-weight:700;color:#00172e}.auth-form .ln-radio-button.checked .checkmark{display:block}.auth-form .divider{text-align:center;font:bold 14px/24px Lato,'Helvetica Neue',Arial,sans-serif}.auth-form .divider span{display:flex;position:relative;place-content:center}.auth-form .divider span::after,.auth-form .divider span::before{content:\"\";position:absolute;height:1px;border-top:1px solid #cfd8dc;top:12px;width:calc(50% - 32px)}.auth-form .divider span::after{left:50%;margin-left:32px}.auth-form .divider span::before{right:50%;margin-right:32px}.auth-form .ln-verification-code legend{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:700;font-size:16px;line-height:24px}.auth-form .ln-verification-code .ln-input{color:#455a64;font:24px/40px Lato,'Helvetica Neue',Arial,sans-serif;height:64px;min-width:24px;padding:4px;text-align:center;width:10%}.auth-form .ln-verification-code>:nth-last-child(n+2){margin-right:8px}.auth-form .security-hidden{-webkit-text-security:disc}.auth-form p{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:400;font-size:18px;line-height:32px}.auth-form .ln-button-brand{margin-top:16px}@media (min-width:600px){.auth-form .ln-form-group{justify-content:space-between;flex-wrap:wrap;flex-direction:row}.auth-form .ln-form-group>:nth-last-child(n+2){margin-bottom:0}.auth-form .ln-form-group .flex-spacer{display:flex}.auth-form .ln-form-group .links{display:flex;justify-content:right}.auth-form .ln-form-group .links>:nth-last-child(n+2){margin-right:16px}.auth-form .ln-verification-code .ln-input{width:8%}}@media (min-width:1024px){.auth-form .ln-form-group{display:flex;flex-direction:column}.auth-form .ln-form-group>:nth-last-child(n+2){margin-bottom:32px}.auth-form .ln-form-group .flex-spacer{display:none;flex:1}.auth-form .ln-form-group .links{display:flex;justify-content:space-between}.auth-form .ln-form-group .links a{text-decoration:underline;font:16px/24px Lato,'Helvetica Neue',Arial,sans-serif;color:#0d47a1}.auth-form .ln-button-brand{margin-top:24px}}@media (min-width:1920px){.auth-form .ln-form-group{justify-content:space-between;flex-wrap:wrap;flex-direction:row}.auth-form .ln-form-group>:nth-last-child(n+2){margin-bottom:0}.auth-form .ln-form-group .flex-spacer{display:flex}.auth-form .ln-form-group .links{display:flex;justify-content:right}.auth-form .ln-form-group .links>:nth-last-child(n+2){margin-right:16px}.auth-form .ln-verification-code .ln-input{font:32px/40px Lato;width:6%}.auth-form .ln-verification-code>:nth-last-child(n+2){margin-right:12px}.auth-form .ln-button-brand{margin-top:32px}}"]
        })
    ], AuthLayout);
    return AuthLayout;
}());

var AuthLayoutModule = /** @class */ (function () {
    function AuthLayoutModule() {
    }
    AuthLayoutModule = __decorate([
        NgModule({
            declarations: [AuthLayout],
            imports: [CommonModule],
            exports: [AuthLayout],
        })
    ], AuthLayoutModule);
    return AuthLayoutModule;
}());

/*
 * Public API Surface of auth-layout
 */

var AuthFooter = /** @class */ (function () {
    function AuthFooter() {
    }
    AuthFooter = __decorate([
        Component({
            selector: prefix + "-auth-footer",
            template: "<footer aria-label=\"Footer\">\n  <!-- <div class=\"country-language-toggle\"> --- not implemented\n    <ng-content select=\"[country-language-toggle]\"></ng-content>\n  </div> -->\n  <div class=\"footer-links\">\n    <ng-content select=\"[footer-links]\"></ng-content>\n  </div>\n</footer>\n",
            encapsulation: ViewEncapsulation.None,
            styles: ["footer{display:flex;flex-direction:column;color:#455a64}footer a{font-family:Lato,'Helvetica Neue',Arial,sans-serif;font-style:normal;font-weight:400;font-size:14px;text-decoration:none;color:inherit;line-height:17px}footer>:nth-last-child(n+2){padding-bottom:16px}footer .footer-logo-left span{padding-left:8px}footer .country-language-toggle .toggle-link{display:flex;align-items:center}footer .country-language-toggle .toggle-link span{padding-left:8px}footer .footer-links ul{list-style-type:none;display:flex;flex-direction:column}footer .footer-links ul li{padding:16px 0;border-top:1px solid #eee}footer .footer-links ul li a{font-weight:700}footer .footer-links ul :first-child,footer .footer-links ul li.footer-logo{border-top:none}@media (min-width:1024px){footer{color:#fff}footer>:nth-last-child(n+2){padding-bottom:32px}footer .country-language-toggle{justify-content:right;display:flex;align-items:flex-end}footer .footer-links ul{flex-direction:row;flex-wrap:wrap;display:flex}footer .footer-links ul li{padding:0;border:none}footer .footer-links ul li a{font-weight:400}footer .footer-links ul li.footer-logo-left{flex:1}footer .footer-links ul li.footer-logo{flex:1;align-items:center;justify-content:flex-end;display:flex}footer .footer-links ul li+li{padding-left:16px}}@media (min-width:1920px){footer>:nth-last-child(n+2){padding-bottom:0}footer .country-language-toggle{justify-content:right;display:flex;align-items:flex-end}footer .footer-links ul li.footer-logo-left{flex:1}footer .footer-links ul li+li,footer .footer-links ul li.footer-logo{padding-left:32px}}"]
        })
    ], AuthFooter);
    return AuthFooter;
}());

var AuthFooterModule = /** @class */ (function () {
    function AuthFooterModule() {
    }
    AuthFooterModule = __decorate([
        NgModule({
            exports: [AuthFooter],
            declarations: [AuthFooter],
            imports: [CommonModule],
        })
    ], AuthFooterModule);
    return AuthFooterModule;
}());

/*
 * Public API Surface of auth-auth-footer
 */

/*
 * Public API Surface of ln-templates-angular components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthFooter, AuthFooterModule, AuthLayout, AuthLayoutModule, Breakpoints, GlobalSearchAutocompleteComponent, GlobalSearchAutocompleteSectionComponent, GlobalSearchButtonComponent, GlobalSearchInputComponent, GlobalSearchOptionsMenuComponent, GlobalSearchboxComponent, GlobalSearchboxModule, GlobalSearchboxServiceProvider, GlobalExpandingTextAreaComponent as ɵa, prefix as ɵb };
//# sourceMappingURL=ln-templates-angular.js.map
